import { FieldType, FormControlModel, PROMPTS, WidthClass } from '@thehubz/client/core';
import { AssetTypeEnum } from '@thehubz/shared/model';

/**
 * Lufthansa general information forms
 * @returns
 */
export const lufthansaGeneralInformationFields = (): FormControlModel[] => {
  const formFields: FormControlModel[] = [
    {
      formTypeId: '1',
      formFieldName: 'name',
      fieldType: FieldType.Text,
      fieldLabel: $localize`Asset name`,
      placeholder: $localize`:placeholder:Asset name`,
      inputType: 'text',
      disable: true,
      validators: {
        required: true,
      },
      widthClass: WidthClass.WFull,
      value: '',
      visible: true,
    },
    {
      formTypeId: '3',
      formFieldName: 'status',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Status`,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      widthClass: WidthClass.W12,
      validators: {
        required: true,
      },
      value: undefined,
      options: [],
      visible: true,
    },
    {
      formTypeId: '2',
      formFieldName: 'agency',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Agency`,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      widthClass: WidthClass.W12,
      validators: {
        required: true,
      },
      value: undefined,
      dropDownSearch: true,
      disableSingleSelect: true,
      options: [],
      visible: true,
    },
    {
      formTypeId: '1',
      formFieldName: 'client',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Client`,
      repeatFieldLabel: true,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      widthClass: WidthClass.W12,
      validators: {
        required: true,
      },
      value: undefined,
      dropDownSearch: true,
      disableSingleSelect: true,
      options: [],
      visible: true,
    },
    {
      formTypeId: '2',
      formFieldName: 'brand',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`User group`,
      repeatFieldLabel: true,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      widthClass: WidthClass.W12,
      validators: {
        required: true,
      },
      value: undefined,
      dropDownSearch: true,
      disableSingleSelect: true,
      options: [],
      visible: true,
    },
    {
      formTypeId: '3',
      formFieldName: 'publishStartDate',
      fieldType: FieldType.Date,
      fieldLabel: $localize`Release date: from`,
      placeholder: $localize`DD/MM/YYYY`,
      minDate: new Date(),
      widthClass: WidthClass.W14,
      value: '',
      visible: true,
    },
    {
      formTypeId: '4',
      formFieldName: 'publishEndDate',
      fieldType: FieldType.Date,
      fieldLabel: $localize`to`,
      placeholder: $localize`DD/MM/YYYY`,
      minDate: new Date(),
      widthClass: WidthClass.W14,
      value: '',
      visible: true,
    },
    {
      formTypeId: '4',
      formFieldName: 'iptc_photoGrapher',
      fieldType: FieldType.Text,
      editOnly: true,
      fieldLabel: $localize`Photographer`,
      placeholder: $localize`Photographer`,
      inputType: 'text',
      assetType: AssetTypeEnum.Image,
      widthClass: WidthClass.W12,
      value: '',
      visible: true,
    },
    {
      formTypeId: '4',
      formFieldName: 'iptc_source',
      fieldType: FieldType.Text,
      editOnly: true,
      fieldLabel: $localize`Source`,
      placeholder: $localize`Source`,
      inputType: 'text',
      assetType: AssetTypeEnum.Image,
      widthClass: WidthClass.W12,
      value: '',
      visible: true,
    },
    {
      formTypeId: '4',
      formFieldName: 'iptc_creator',
      fieldType: FieldType.Text,
      editOnly: true,
      fieldLabel: $localize`Creator`,
      placeholder: $localize`Creator`,
      inputType: 'text',
      assetType: AssetTypeEnum.Video,
      widthClass: WidthClass.W12,
      value: '',
      visible: true,
    },
    {
      formTypeId: '4',
      formFieldName: 'iptc_copyRight',
      fieldType: FieldType.Text,
      editOnly: true,
      fieldLabel: $localize`Copyright flag`,
      placeholder: $localize`Copyright flag`,
      inputType: 'text',
      assetType: AssetTypeEnum.Video,
      widthClass: WidthClass.WFull,
      value: '',
      visible: true,
    },
    {
      formTypeId: '4',
      formFieldName: 'adminComment',
      fieldType: FieldType.Text,
      fieldLabel: $localize`Comment`,
      placeholder: $localize`Comment`,
      inputType: 'text',
      widthClass: WidthClass.W12,
      accessibilityRole: 'commentfield',
      value: '',
      visible: true,
    },
    {
      formTypeId: '9',
      formFieldName: 'iptc_description',
      fieldType: FieldType.Textarea,
      editOnly: true,
      fieldLabel: $localize`IPTC Description`,
      placeholder: $localize`IPTC Description`,
      inputType: 'text',
      widthClass: WidthClass.WFull,
      value: '',
      visible: true,
    },
    {
      formTypeId: '11',
      formFieldName: 'plannedDeletionToggle',
      fieldType: FieldType.Checkbox,
      fieldLabel: $localize`Planned for deletion`,
      placeholder: '',
      editOnly: true,
      widthClass: WidthClass.W13,
      value: '',
      visible: true,
    },
    {
      formTypeId: '12',
      formFieldName: 'plannedDeletion',
      fieldType: FieldType.Date,
      fieldLabel: $localize`Deletion date`,
      placeholder: $localize`DD/MM/YYYY`,
      minDate: new Date(),
      widthClass: WidthClass.W13,
      value: '',
      editOnly: true,
      disable: true,
      validators: {
        required: true,
      },
      visible: true,
    },
  ];
  return formFields;
};
